import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import useStyles from "../style";

const UpdateKYC = ({
  showModal,
  setShowModal,
  handleUpdateKYCLimit,
}) => {
  const styles = useStyles();
  const [transLimit, setTransLimit] = useState(0);

  const onHideModal = useCallback(() => {
    const role = { ...showModal };
    role.isVisible = false;
    setShowModal(role);
  }, [showModal, setShowModal]);

  return (
    <Modal
      className={styles.modal}
      show={showModal.isVisible}
      onHide={onHideModal}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        style={{
          borderBottom: "none",
          padding: "2rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        closeButton
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "24px",
            textAlign: "center",
            width: "100%",
            color: "#000",
          }}
        >
          Update Transaction Limit
        </span>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <input
            className="form-control"
            type='number'
            placeholder="Set transaction limit"
            onChange={(e) => setTransLimit(e.target.value)}
            value={transLimit}
          />
        </div>
        <div style={{ display: 'flex', margin: 20, justifyContent: 'center', alignItems: 'center' }}>
          <button className="btn btn-primary" onClick={() => handleUpdateKYCLimit(transLimit)}>Update</button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateKYC;